import React, { useState } from 'react';
import '../styles.css';
import './EnterByHand.css';
import { SERVER_URL } from '../config';

export default function EnterByHandScreen({ addProductToWishlist }) {
    const [name, setName] = useState('');
    const [price, setPrice] = useState('');
    const [imageUrl, setImageUrl] = useState('');
    const [productUrl, setProductUrl] = useState('');
    const [alertMessage, setAlertMessage] = useState(null);

    const handleAddProduct = async () => {
        if (!name || !price || !productUrl) {
            setAlertMessage('Error: Please fill in all fields');
            return;
        }

        const token = JSON.parse(localStorage.getItem('token'));
        try {
            const response = await fetch(`${SERVER_URL}/add-product-manual`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ token, name, price, imageUrl, url: productUrl }),
            });
            const result = await response.json();

            if (result.ok) {
                addProductToWishlist(result.product);
                setAlertMessage('Success: Product added to wishlist');
                setName('');
                setPrice('');
                setImageUrl('');
                setProductUrl('');
            } else {
                setAlertMessage(`Error: ${result.error || 'Failed to add product'}`);
            }
        } catch (error) {
            setAlertMessage('Error: An error occurred while adding the product');
            console.error('Error:', error);
        }
    };

    return (
        <div className="enter-by-hand-container">
            {alertMessage && <div className="alert">{alertMessage}</div>}
            <input
                type="text"
                className="enter-by-hand-input"
                placeholder="Product Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
            />
            <input
                type="text"
                className="enter-by-hand-input"
                placeholder="Price"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                inputMode="numeric"
            />
            <input
                type="text"
                className="enter-by-hand-input"
                placeholder="Image address / URL"
                value={imageUrl}
                onChange={(e) => setImageUrl(e.target.value)}
            />
            <input
                type="text"
                className="enter-by-hand-input"
                placeholder="Product address / URL"
                value={productUrl}
                onChange={(e) => setProductUrl(e.target.value)}
            />
            <button className="enter-by-hand-button" onClick={handleAddProduct}>
                Add Product
            </button>
        </div>
    );
}
